export const ACCESSIBILITY_TEXTS = {
    CART_TOTAL: "Cart total is {0} Rupees",
    PLACE_ORDER: "Place order",
    MAKE_PAYMENT: "Make payment, tap to go to payment",
    PAYMENT_GROUP: "Payment",
};

export const TEXTS = {
    MAKE_PAYMENT: "MAKE PAYMENT",
    PROCEED_TO_PAY: "Proceed to Pay",
    PLACE_ORDER: "Place Order",
    VIEW_DETAILED_BILL: "VIEW DETAILED BILL",
    WITH_X_TIP: "(with ₹{0} tip)",
};
